/**
 * Use this placeholder when you have no data
 */
import './styles.scss';

const NoDataPlaceholder = () =>
  (<div className="noDataPlaceholder">
    <div className="noDataPlaceholder__icon" />
    <h2>No data in requested period.</h2>
  </div>);

export default NoDataPlaceholder;
